<template>
  <div v-if="PERMISSIONS" id="left-menu" class="d-flex flex-column">
    <ul class="menus flex-1">
      <li
        :id="route.name"
        :key="index"
        class="border-bottom-menu"
        v-for="(route, index) in routes"
        v-show="checkAuth(route)"
      >
        <b-collapse :id="route.menuName" v-model="expand">
          <div>
            <ul>
              <li
                :key="idx"
                v-for="(routeChild, idx) in route.children"
                v-show="checkAuth(routeChild)"
              >
                <router-link
                  :to="`${route.path}${routeChild.path}`"
                  @click.native="onClickChildItemMenu()"
                  active-class="is-selected"
                  class="is-child"
                  v-show="routeChild.isShowLeftMenu !== false"
                >
                  <span>{{ routeChild.menuName }}</span>
                </router-link>
              </li>
            </ul>
          </div>
        </b-collapse>
      </li>
      <li>
        <BaseHeaderAccount />
      </li>
    </ul>
    <div class="version">Phiên bản: {{ version }}</div>
  </div>
</template>

<script>
import { removeLeftMenuAndOverlayClass } from "@/utils/headerUtils";
import { hasPermissionUser } from "@/utils/permissionUtils";

import BaseHeaderAccount from "@/components/common/BaseHeaderAccount";
import _isNil from "lodash/isNil";
import { mapGetters } from "vuex";

export default {
  name: "BaseLeftMenu",
  components: {
    BaseHeaderAccount,
  },
  data() {
    return {
      version: "",
      routes: this.$router.options.routes.filter(
        (x) => x.isShowLeftMenu === true
      ),
      expand: true,
    };
  },
  computed: {
    ...mapGetters({
      PERMISSIONS: "common/permissions",
    }),
  },
  created() {
    this.$router.onReady(() => {
      this.routes.forEach((item) => {
        item.children &&
          item.children.forEach((childItem) => {
            if (childItem.name === this.$route.name) {
              item.expand = true;
            }
          });
      });
    });
    this.version = BUILD_VERSION;
  },
  methods: {
    onClickItemMenu(index, Childroute) {
      if (_isNil(Childroute)) {
        removeLeftMenuAndOverlayClass();
      }
      this.routes.forEach((item, i) => {
        item.expand = !item.expand;
        if (i !== index) {
          item.expand = false;
        }
      });
    },
    onClickChildItemMenu() {
      removeLeftMenuAndOverlayClass();
    },
    onMouseoverRouteChild(routeName, routeIndex) {
      document
        .getElementById(`${routeName}${routeIndex}`)
        .classList.add("is-selected");
    },
    onMouseleaveRouteChild(routeName, routeIndex) {
      document
        .getElementById(`${routeName}${routeIndex}`)
        .classList.remove("is-selected");
    },
    checkAuth(route) {
      if (route.meta && route.meta.permissionName) {
        return hasPermissionUser(route.meta.permissionName);
      } else {
        return true;
      }
    },
  },
};
</script>

<style scoped>
.version {
  margin: 15px 0;
  text-align: center;
  color: #a5a5a5;
  font-size: 14px;
}
</style>
